import { render, staticRenderFns } from "./PuntosVenta.vue?vue&type=template&id=408eb0d2&"
import script from "./PuntosVenta.vue?vue&type=script&lang=js&"
export * from "./PuntosVenta.vue?vue&type=script&lang=js&"
import style0 from "./PuntosVenta.vue?vue&type=style&index=0&id=408eb0d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports